<template>
    <div class="sun">
    <div class="ray_box">
        <div class="ray ray1"></div>
        <div class="ray ray2"></div>
        <div class="ray ray3"></div>
        <div class="ray ray4"></div>
        <div class="ray ray5"></div>
        <div class="ray ray6"></div>
        <div class="ray ray7"></div>
        <div class="ray ray8"></div>
        <div class="ray ray9"></div>
        <div class="ray ray10"></div>
    </div>
    </div>
</template>

<script>

  export default {
    name: 'Bird',
    props: ['title']
  }
</script>
  
<style lang="less">
@import "../../styles/global.less";
.sunText {
// -webkit-animation: ray_anim 100s linear infinite;
//     animation: ray_anim 100s linear infinite;
font-size: 10px;
text-align: center;
}

.sun { 
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    margin: auto;  
    width:70px;
    height:70px;
    border-radius:50%;  
    background: rgb(255,255,153);
    opacity:0.9;            
    box-shadow: 0px 0px 40px 15px lightyellow;  
    transform: scale(5);
    z-index: 50000000;
    display: block;
}

.ray_box {
    position: absolute;
    margin: auto;
    top:0px;
    left:0;
    right:0;
    bottom:0;   
    width:70px;  
    -webkit-animation: ray_anim 100s linear infinite;
    animation: ray_anim 100s linear infinite;
}
.ray {  
    background: -webkit-linear-gradient(rgba(190,190,190,0) 0%, rgba(190,190,190,0.8) 50%, rgba(190,190,190,0) 100%);
    background: linear-gradient(rgba(190,190,190,0) 0%, rgba(190,190,190,0.8) 50%, rgba(190,190,190,0) 100%); 
    margin-left:10px;
    // border-radius:0;
    position:absolute;
    opacity:0.1;
    z-index: -10;
    display: block;
}

.ray1 {    
    height:170px;
    width:20px;
   -webkit-transform: rotate(180deg);
    top:-175px;
    left: 15px;
}
.ray2 {
    height:100px;
    width:8px;
   -webkit-transform: rotate(220deg);
    top:-90px;
    left: 75px;
}
.ray3 {
    height:170px;
    width:50px;
   -webkit-transform: rotate(250deg);
    top:-80px;
    left: 100px;
}
.ray4 {
    height:120px;
    width:14px;
   -webkit-transform: rotate(305deg);
    top:30px;
    left: 100px;
}
.ray5 {
    height:140px;
    width:30px;
   -webkit-transform: rotate(-15deg);
    top:60px;
    left: 40px;
}
.ray6 {
    height:90px;
    width:50px;
   -webkit-transform: rotate(30deg);
    top:60px;
    left: -40px;
}
.ray7 {
    height:180px;
    width:10px;
   -webkit-transform: rotate(70deg);
    top:-35px;
    left: -40px;
    display: none;
}
.ray8 {
    height:120px;
    width:30px;
   -webkit-transform: rotate(100deg);
    top:-45px;
    left:-90px;
}
.ray9 {
    height:80px;
    width:10px;
   -webkit-transform: rotate(120deg);
    top:-65px;
    left:-60px;
}
.ray10 {
    height:190px;
    width:23px;
   -webkit-transform: rotate(150deg);
    top:-185px;
    left: -60px;
}

@keyframes ray_anim { 
    0% { -webkit-transform: rotate(0deg); transform: rotate(0deg);}    
    100% { -webkit-transform: rotate(360deg); transform: rotate(360deg);}
}

@media screen and (max-width: @breakpoint1) {
    .sun {
        transform: scale(3);
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/library/sun.vue